module.exports = __webpack_public_path__ + "img/service-vodio.bd6ecc87.png";